import { useQuery } from "@tanstack/react-query";
import type {
	TestShackReportFilterOptions,
	TestShackReportFiltersRequest,
} from "../../models/TestShackReport";
import { getTestShackReportFilters } from "../../repositories/TestShackReportRepository";

interface UseTestShackReportFiltersQueryProps
	extends TestShackReportFiltersRequest {
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useTestShackReportFiltersQuery = ({
	enabled = true,
	onError,
	...request
}: UseTestShackReportFiltersQueryProps) =>
	useQuery<TestShackReportFilterOptions, Error>({
		queryKey: [
			"test-shack-report-filters",
			request.assetId,
			request.startDate?.getTime() ?? null,
			request.endDate?.getTime() ?? null,
			request.shiftId,
			request.sectionId,
			request.eventId,
		],
		meta: { realtime: ["DIM.GetProfileInspectionReportFilters"] },
		queryFn: ({ signal }) => getTestShackReportFilters(request, signal),
		enabled,
		onError,
	});
